export default __webpack_public_path__ + "static/media/adsform-sec2-bg-big.6e004f68.jpg";